<ng-container *ngIf="!areDetailsLoading">
  <div class="center">
    <div style="padding: 20px; overflow-y: scroll; width: 100%; max-width: 750px;"
      [ngStyle]="{'padding-bottom': (isScheduled()) ? '120px' : '80px'}">
      <div class="space-between">
        <div class="d-flex f-column d-start mb-4">
          <span class="header">{{
            details.type | translateEnum: "actionType"
          }}</span>
          <span class="subHeader">{{ getStatusLabel() }}</span>
        </div>
        <i *ngIf="details.urgency" class="fas fa-exclamation color-red"></i>
      </div>
      <div class="d-flex f-column d-start f-grow p-8 mb-2 textColor">
        <span class="mb-2" *ngIf="details.instructions">
          <i class="fa fa-info-circle gray mr-2"></i>
          {{ details.instructions }}
        </span>
        <span class="mb-2" *ngIf="details?.issues[0]">
          <i class="fa fa-building gray mr-2"></i>
          {{ details.issues[0].buildingLabel }}
        </span>
        <span class="mb-2" *ngIf="getIssueLocation(details?.issues[0])">
          <i class="fas fa-map-marker gray mr-2"></i>
          {{ getIssueLocation(details.issues[0]) }}
        </span>
        <span class="mb-2"
              [attr.title]="Localization.WorkOrderReference | translate"
              *ngIf="details.workOrderReference">
          <i class="fas fa-receipt gray mr-2"></i>
          {{ details.workOrderReference }}
        </span>
      </div>

      <div *ngIf="details.feedback && details.feedback != 'null' && details.feedback.length > 0" class="d-flex flex-column">
        <mat-divider class="mb-4"></mat-divider>
        <span class="sub-header">
          <i class="fas fa-comments gray mr-2"></i>
          {{ Localization.Feedback | translate }}
        </span>
        <span class="mb-4 textColor">{{details.feedback}}</span>
      </div>

      <mat-divider *ngIf="details.multimedia.length > 0" class="mb-4"></mat-divider>

      <div *ngIf="details.multimedia.length > 0" class="mb-4">
        <chapps-multimedium *ngFor="let multimedium of details.multimedia; index as i" class="ml-2 mr-2"
          [model]="multimedium" (clicked)="openMediaInMultimediaViewer(details.multimedia, i)" [deletable]="false">
        </chapps-multimedium>
      </div>
      <div *ngIf="buildingManager" class="d-flex f-column d-start f-grow p-8 mb-2 textColor">
        <span class="sub-header">{{ Localization.BuildingManager | translate }}</span>
        <div>
          <div class="mb-1">
            <i class="fas fa-user gray mr-2"></i>{{ buildingManager.firstName + " " + buildingManager.lastName }}
          </div>
          <div *ngIf="buildingManager.mobile || buildingManager.telephone">
            <i class="fas fa-phone gray mr-2"></i><span>{{buildingManager.mobile ? buildingManager.mobile : buildingManager.telephone}}</span>
          </div>
        </div>
        <span class="mb-2" *ngIf="details.dueDate">
          <i class="fa fa-calendar gray mr-2"></i>
          {{ Localization.RequiredByTheEndOf | translate }}
          {{ details.dueDate | date: applicationConfig.DATE_FORMAT }}
        </span>
      </div>

      <div *ngIf="buildingTenant" class="d-flex f-column d-start f-grow p-8 mb-2 textColor">
        <span class="sub-header">{{ Localization.Resident | translate }}</span>
        <div>
          <div class="mb-1">
            <i class="fas fa-user gray mr-2"></i>{{ buildingTenant.firstName + " " + buildingTenant.lastName }}
          </div>
          <div *ngIf="buildingManager.mobile || buildingManager.telephone">
            <i class="fas fa-phone gray mr-2"></i><span>{{buildingTenant.mobile ? buildingTenant.mobile : buildingTenant.telephone}}</span>
          </div>
        </div>
      </div>
      <mat-divider class="mb-4"></mat-divider>
      <div class="d-flex f-column d-start f-grow p-8 mb-2 textColor">
        <span class="sub-header">
          <i class="fa fa-info-circle gray mr-2"></i>
          {{ Localization.Issues | translate }}
        </span>
        <div *ngFor="let issue of details.issues; index as i" class="d-flex f-column d-start f-grow p-8 mb-2 textColor" style="width: 100%;">
          <span class="mb-2 fw-regular">
            <i class="fas fa-circle gray mr-2"><span class="issueNumber">{{ (i + 1).toString() }}</span></i>
            {{ issue.title }}
          </span>
          <span class="mb-2" *ngIf="issue.description">
            <i class="fa fa-info-circle gray mr-2"></i>{{ issue.description }}
          </span>
          <span class="mb-2" *ngIf="getIssueLocation(issue)">
            <i class="fas fa-map-marker gray mr-2"></i>
            {{ getIssueLocation(issue) }}
          </span>
          <span class="mb-2">
            <i class="fas fa-user gray mr-2"></i>
            {{ issue.creatorFirstName }} {{ issue.creatorLastName}}
          </span>
          <span *ngIf="issue.multimedia.length > 0" class="mb-2 space-between"
            style="width: 100%">
            <span>
              <i class="fa fa-image gray mr-2"></i>
              {{ issue.multimedia.length }} {{ Localization.Photos | translate }}
            </span>
            <span>
              <button mat-button *ngIf="!isMediaEmpty(issue)" class="mb-0" (click)="toggleImagesHide()" style="line-height: 0;">
                {{ (showLess ? Localization.HideImages : Localization.ShowImages) | translate  }}
                <i [ngClass]="{
                    'fa gray mr-2 w-14': true,
                    'fa-chevron-down': !showLess,
                    'fa-chevron-up': showLess
                  }"></i>
              </button>
            </span>

          </span>
          <div [ngClass]="{ 'images-less': !showLess, 'images-more': showLess }">
            <chapps-multimedium *ngFor="let multimedium of issue.multimedia; index as i" class="ml-2 mr-2"
              [model]="multimedium" (clicked)="openMediaInMultimediaViewer(issue.multimedia, i)" [deletable]="false">
            </chapps-multimedium>
          </div>
        </div>
      </div>

      <mat-divider class="mb-4"></mat-divider>

      <div class="center">
        <a [routerLink]="'../..'" mdbWavesEffect class="backButton">
          <i class="fa fa-chevron-left ml-1" aria-hidden="true"></i>
          {{ Localization.BackToJobs | translate }}
        </a>
      </div>
    </div>
  </div>
  <div class="job-bottom">
    <div class="center job-scheduled" *ngIf="isScheduled()">
      <span [translate]="Localization.JobScheduledOn"
        [translateParams]="{scheduledOn: details.scheduledOn | date: applicationConfig.DATE_FORMAT}">Job accepted and
        scheduled for 00/00/0000</span>
    </div>
    <div class="center job-actions" *ngIf="canAccept() || canExecute() || canDecline()">
      <chapps-success-button *ngIf="canAccept()" [small]="true" [label]="Localization.Accept | translate"
        (clicked)="accept()">
      </chapps-success-button>
      <chapps-success-button *ngIf="canExecute()" [small]="true" [label]="Localization.Finish | translate"
        (clicked)="execute()">
      </chapps-success-button>
      <chapps-danger-button *ngIf="canDecline()" [small]="true" [label]="Localization.Decline | translate"
        (clicked)="decline()">
      </chapps-danger-button>
    </div>
  </div>
</ng-container>
<app-card-spinner [show]="areDetailsLoading"></app-card-spinner>
<app-accept-modal [id]="this.id" [culture]="getCulture()" (success)="onAccepted()"></app-accept-modal>
<app-decline-modal [id]="this.id" [readonly]="this.readonly" [type]="this.details.type" (success)="onCompleted()">
</app-decline-modal>
<app-execute-modal [id]="this.id" [readonly]="this.readonly" [type]="this.details.type" (success)="onCompleted()">
</app-execute-modal>
